module.exports = __webpack_public_path__ + "static/gallery_yarra_3_thumb-12a13bfa4f11d2b1a28fa3e78c9674b9.jpg";